import { render, staticRenderFns } from "./company-pop.vue?vue&type=template&id=65942a36&"
import script from "./company-pop.vue?vue&type=script&lang=js&"
export * from "./company-pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "company-pop.vue"
export default component.exports